import { LockerPluginOptions } from '../data/LockerDataTypes';

const defaultLockerPluginOptions : LockerPluginOptions = {
    clientId: '',
    countryCode: 'RO',
    langCode: 'en',
    county: '',
    city: '',
    favLockerId: -1,
    theme: '',
    apiUsername: undefined,
    filters: undefined
};

const parseQueryParams = (query: string): LockerPluginOptions => {
    const options = { ...defaultLockerPluginOptions };

    if (!query) {
        return options;
    }

    const parsePluginOptionsParam = (value:string, key:string):void => {
        if(!value) return;
        let v: any;
        switch(key as keyof LockerPluginOptions){
            case 'filters':
                v = JSON.parse(value);
                break;
            case 'favLockerId':
                v = +value;
                break;
            default: 
                v = value;
                break;
        }
        (<any>options)[key] = v;
    };
    const searchParams = new URLSearchParams(query);
    searchParams.forEach(parsePluginOptionsParam);
    return options;
}

export function getLockerPluginOptions(): LockerPluginOptions {
    return parseQueryParams(window.location.search);
}